/* Draft-theme UI restriction only; Judge.me's server-side media settings are unchanged. */
(() => {
  const update = () => {
    document.querySelectorAll('.jdgm-write-review-modal__media-input').forEach(input => {
      input.disabled = true;
      const field = input.closest('.jdgm-write-review-modal__field-group--media-upload');
      if (field) field.hidden = true;
      const group = input.closest('.jdgm-write-review-modal__form-group--share-media');
      if (group && !group.querySelector('.az-review-media-note')) {
        const note = document.createElement('p');
        note.className = 'az-review-media-note';
        note.textContent = document.documentElement.lang === 'ka'
          ? 'ამ სატესტო გვერდზე ფოტოს ატვირთვა გამორთულია. გააგრძელეთ ფოტოს გარეშე.'
          : 'Photo uploads are disabled on this test page. Continue without a photo.';
        group.appendChild(note);
      }
    });
  };
  update();
  new MutationObserver(update).observe(document.body, { childList: true, subtree: true });
})();